import React from "react";
import { MapPin, Mail } from "lucide-react";
import { CONTATTI } from "../../data/content";
import Reveal from "./Reveal";

export const Contatti = () => (
  <section id="contatti" data-testid="contatti-section" className="bg-navy text-white py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 grid lg:grid-cols-2 gap-12">
      <div>
        <Reveal>
          <p className="font-sub uppercase tracking-[0.3em] text-gold font-bold text-sm mb-4">Contatti</p>
          <h2 className="font-heading uppercase leading-[0.9] text-white text-4xl md:text-6xl tracking-tight">
            Vieni a trovarci a Tricesimo
          </h2>
        </Reveal>

        <div className="mt-10 space-y-6">
          <Reveal delay={0.05}>
            <div className="flex gap-4" data-testid="contact-address">
              <MapPin className="text-court shrink-0 mt-1" />
              <div>
                <div className="font-sub uppercase font-bold tracking-wide">{CONTATTI.sede}</div>
                <div className="font-body text-white/70">{CONTATTI.address}</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <a href={`mailto:${CONTATTI.email}`} data-testid="contact-email" className="flex gap-4 group">
              <Mail className="text-court shrink-0 mt-1" />
              <div>
                <div className="font-sub uppercase font-bold tracking-wide">Email</div>
                <div className="font-body text-white/70 group-hover:text-court transition-colors">{CONTATTI.email}</div>
              </div>
            </a>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="flex gap-3 pt-2">
              {CONTATTI.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  data-testid={`social-${s.label}`}
                  className="border border-white/30 px-4 py-2 font-sub uppercase text-xs tracking-widest hover:bg-court hover:border-court transition-colors"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal y={60}>
        <div className="h-full min-h-[400px] border-4 border-court relative overflow-hidden" data-testid="contact-map">
          <iframe
            title="Mappa Tricesimo"
            src="https://www.openstreetmap.org/export/embed.html?bbox=13.2113%2C46.1571%2C13.2233%2C46.1631&layer=mapnik&marker=46.160072%2C13.217266"
            className="w-full h-full grayscale contrast-125"
            style={{ border: 0, filter: "grayscale(1) contrast(1.1)" }}
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 bg-gold text-navy font-heading uppercase text-xl px-5 py-2">
            Tricesimo · Udine
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Contatti;
